const NAMESPACE = "archiveDefModal";

const KEYS = {
    noBlockingReferencesMessage: "noBlockingReferencesMessage",
    archivedFieldNote: "archivedFieldNote",
    archivedNameLabel: "archivedNameLabel",
    archiveEmptyNameWarning: "archiveEmptyNameWarning",
    textValidationRuleWarning: "textValidationRuleWarning"
};

const MESSAGES = {
    [KEYS.noBlockingReferencesMessage]: {
        value: "No blocking references found - OK to archive.",
        comment: "There is no reference to the item in PowerClerk, so it is okay to archive it"
    },
    [KEYS.archivedFieldNote]: {
        value: "NOTE: Archived data fields are no longer available in PowerClerk to be selected for any design feature. Existing project data will not be affected.",
        comment: "Note to user that once archived, the fields are not visible in other areas."
    },
    [KEYS.textValidationRuleWarning]: {
        value: 'The Text Validation Rule "{tvrName}" currently applied to this Data Field will be removed upon archiving. If unarchived, the Text Validation Rule will not be automatically restored.',
        comment:
            "Note to user that any text validation rules currently applied to a data field will be removed upon archiving"
    },
    [KEYS.archivedNameLabel]: {
        value: "Archived name",
        comment: "Label for the archive name input"
    },
    [KEYS.archiveEmptyNameWarning]: {
        value: "Archived name cannot be empty.",
        comment: "Warning when the name field is left blank"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
